import { render, staticRenderFns } from "./daping.vue?vue&type=template&id=cf570128&"
import script from "./daping.vue?vue&type=script&lang=ts&"
export * from "./daping.vue?vue&type=script&lang=ts&"
import style0 from "./daping.vue?vue&type=style&index=0&id=cf570128&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports